import { css } from '@emotion/react';
import { AppLinkClasses } from '~/components/AppLink';
import { SquareBodyItemClasses } from '~/modules/symbolQuote/square/BodyItem';
import { store } from '~/pages/heineken_template/_private/store';
import styleds from '~/pages/sungop/_private/styleds';
import ManualSignal from '~/modules/investment-consultant/signalNotify/ManualSignal';
export const sungopStock_initStyling = (templateProps) => {
    store.charting.darkOverrides = {
        // 'mainSeriesProperties.candleStyle.borderDownColor': '#cacaca',
        // 'mainSeriesProperties.candleStyle.borderUpColor': '#cacaca',
        'paneProperties.vertGridProperties.color': '#343434',
        'paneProperties.horzGridProperties.color': '#343434',
        'paneProperties.background': '#151515',
        'mainSeriesProperties.candleStyle.borderDownColor': '#00ff00',
        'mainSeriesProperties.candleStyle.borderUpColor': '#ff2e26',
    };
    templateProps.globalCssset = css `
    /* 在最窄的螢幕280px上也可以開關Drawer */
    #__next {
      .Drawer1 {
        width: 300px;
      }
    }
    /* ${ManualSignal.classes.titleContent} {
        background-color: #212532;
        border-radius: 4px;
      }
      .${SquareBodyItemClasses.Container} {
        background-color: #212532;
        border: 0px;
        &:hover {
          background-color: #2e303dcc;
        }
      }
      .${SquareBodyItemClasses.ItemName} {
        background-color: #2c303f;
      }
    }

    ${styleds.PageMenuBox} {
      ${AppLinkClasses.Root} {
        color: white;
        height: 32px;
        font-size: 18px;
        padding-left: 16px;
        padding-top: 4px;
        padding-bottom: 4px;
        padding-right: 0;

        :hover {
          border-left: 4px solid rgb(163 163 163);
          background-color: #414141;
        }
      }
    } */
  `;
};
